import { useLocation } from 'react-router-dom';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import { CookieConsent } from '../CookieConsent/CookieConsent';
import { NewsletterPopup } from '../NewsletterPopup/NewsletterPopup';
import { NewsletterSection } from '../NewsletterSection/NewsletterSection';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';
import './style.less';

// Pages where newsletter section should be hidden
const HIDE_NEWSLETTER_PATHS = ['/contact', '/privacy-policy'];

export const Layout = ({ children }) => {
  const location = useLocation();
  const showNewsletter = !HIDE_NEWSLETTER_PATHS.includes(location.pathname);

  // Initialize Google Analytics (only if user consented)
  useGoogleAnalytics();

  return (
    <div className="layout">
      <Header />
      <main className="main-content">{children}</main>
      {showNewsletter && <NewsletterSection />}
      <Footer />
      <CookieConsent />
      <NewsletterPopup />
    </div>
  );
};
